import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { membershipApi } from "./client";

export const membershipKeys = {
  all: ["membership"] as const,
  settings: () => [...membershipKeys.all, "settings"] as const,
  eligibleMenuOptions: () =>
    [...membershipKeys.all, "eligible-menu-options"] as const,
  productLaunches: (variantIds?: string[]) =>
    [...membershipKeys.all, "product-launches", variantIds ?? []] as const,
};

export function useProductLaunchesQuery(variantIds: string[]) {
  return useQuery({
    queryKey: membershipKeys.productLaunches(variantIds),
    enabled: variantIds.length > 0,
    queryFn: () => membershipApi.listProductLaunches(variantIds),
  });
}

export function useUpsertProductLaunch() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({
      variantId,
      payload,
    }: {
      variantId: string;
      payload: { goldFreeEnabled: boolean; launchAt?: string };
    }) => membershipApi.upsertProductLaunch(variantId, payload),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: membershipKeys.all });
    },
  });
}
